import React from 'react';
import { Badge } from '../../../components/ui/Badge';
import { InvoiceStatus } from '../../../core/models/Invoice';

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
}

export const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({ status }) => {
  const getStatusColor = (status: InvoiceStatus) => {
    switch (status) {
      case InvoiceStatus.PAID:
        return 'success';
      case InvoiceStatus.SENT:
      case InvoiceStatus.VIEWED:
        return 'default';
      case InvoiceStatus.OVERDUE:
        return 'error';
      case InvoiceStatus.CANCELLED:
        return 'error';
      default:
        return 'warning';
    }
  };

  return (
    <Badge variant={getStatusColor(status)}>
      {status}
    </Badge>
  );
};
